import React, { useEffect, useState, useMemo } from "react";
import { GeneralContainer } from "./ManageEventContainer.styled";
import { useLocation, useHistory } from "react-router-dom";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  ALL_CATEGORIES,
  ALL_LANGUAGES,
  ALL_ROLES_BY_LEVEL,
  ALL_SPEAKERS,
  COUNTRIES_BY_CLIENT,
  EVENT_BY_ID,
  USERS_ADVANCE_SEARCH,
  USERS_BY_IDS,
  USERS_IN_ROLE2,
  ALL_LOBS_COUNTRY,
} from "../../GraphQL/Queries";
import { DELETE_RECURRENCE } from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import ManageEvent from "../../components/ManageEvent";
import { clientWellness } from "../../App";
import { RRule } from "rrule";
import moment from "moment";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";

const ManageEventContainer = () => {
  const user = useMemo(() => getStateLoginComplete(), []);
  const location = useLocation();
  const history = useHistory();
  const [action, setAction] = useState("");
  const [idEvent, setIdEvent] = useState("");
  const [usersAdvanceSearch, setUsersAdvanceSearch] = useState();
  const [detailEvent, setDetailEvent] = useState({});
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [speakers, setSpeakers] = useState();
  const [guestsData, setGuestsData] = useState();
  const [individualGuests, setIndividualGuests] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [allLobs, setAllLobs] = useState();
  const [allRolesByLevel, setAllRolesByLevel] = useState([]);
  const clientId = useMemo(() => user.clientId, []);
  const [selectedComoNonComo, setSelectedComoNonComo] = useState(null);
  const [showCreateSpeaker, setShowCreateSpeaker] = useState(false);
  const [showAdvanceOption, setShowAdvanceOption] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [selectedRole, setSelectedRole] = useState();
  const [selectedLob, setSelectedLob] = useState();
  const [showEventRecurring, setShowEventRecurring] = useState(false);
  const [activeEndsRecurring, setActiveEndsRecurring] = useState();
  const [repeatEvery, setRepeatEvery] = useState();
  const [periodRecurring, setPeriodRecurring] = useState();
  const [dataButtonDaysValue, setDataButtonDaysValue] = useState([]);
  const [onEndRecurring, setOnEndRecurring] = useState(null);
  const [showUpdateRecurringButton, setShowUpdateRecurringButton] =
    useState(false);
  const [openDeleteRecurringModal, setOpenDeleteRecurringModal] =
    useState(null);
  const dateOptions = useMemo(() => [
    { value: 0, label: "Day" },
    { value: 1, label: "Week" },
    { value: 2, label: "Month" },
    { value: 3, label: "Year" },
  ], []);
  const dataButtonDays = useMemo(() => [
    { label: "M", value: "Monday" },
    { label: "T", value: "Tuesday" },
    { label: "W", value: "Wednesday" },
    { label: "T", value: "Thursday" },
    { label: "F", value: "Friday" },
    { label: "S", value: "Saturday" },
    { label: "S", value: "Sunday" },
  ], []);
  const days = useMemo(() => [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ], []);
  const positionOfTheWeek = useMemo(() => [
    "first",
    "second",
    "third",
    "fourth",
    "fifth",
    "sixth",
    "seventh",
  ], []);
  const dataEndsDate = useMemo(() => [
    { value: "never", label: "Never" },
    { value: "on", label: "On" },
  ], []);
  const dateOfToday = useMemo(() => new Date(), []);
  const dayOfToday = useMemo(() => new Date().getDate(), []);
  const dayOfTheMonth = useMemo(() => days[new Date(dateOfToday).getDay()], []);
  const numberWeek = useMemo(() => Math.ceil(new Date(dateOfToday).getDate() / 7), []);
  const optionForMonth = useMemo(() => [
    { value: 0, label: "Monthly on day " + dayOfToday },
    {
      value: 1,
      label:
        "Monthly on the " +
        positionOfTheWeek[numberWeek - 1] +
        " " +
        dayOfTheMonth,
    },
  ], []);
  const [optionForMonthSelected, setOptionForMonthSelected] = useState();
  const [recurringEvents, setRecurringEvents] = useState([]);
  const [recurrence, setRecurrence] = useState({
    lastOcurrence: null,
    recurrencePattern: "",
  });
  const [dataRecurrence, setDataRecurrence] = useState();
  const [renderAgain, setRenderAgain] = useState(false);

  const [deleteRecurrence] = useMutation(DELETE_RECURRENCE, {
    client: clientWellness,
  });

  const [runQueryUsersAdvanceSearch] = useLazyQuery(USERS_ADVANCE_SEARCH, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfUsersAdvanceSearch = data.userListAdvancedSearch.map(
        (element) => {
          return element;
        }
      );
      setUsersAdvanceSearch(resultOfUsersAdvanceSearch);
    },
  });

  const [
    runQueryEventById,
    { loading: loadingEventById, error: errorEventById },
  ] = useLazyQuery(EVENT_BY_ID, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.eventById !== null && data.eventById) {
        let detail = data.eventById;
        setDetailEvent(detail);
      } else {
        NotificationManager.error(
          "Something is wrong with the detail of the event",
          "",
          5000
        );
      }
    },
  });

  const [runQueryCategories] = useLazyQuery(ALL_CATEGORIES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCategories = data?.allCategories?.map((element) => {
        return {
          value: element?.idCategory,
          label: element?.categoryName,
        };
      });
      setCategories(resultOfAllCategories);
    },
  });

  const [runQueryCountryByClient] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data?.countryLocationList?.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setCountries(resultOfAllCountries);
    },
  });

  const [runQueryLanguages] = useLazyQuery(ALL_LANGUAGES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfLanguages = data?.allLanguages?.nodes?.map((element) => {
        return {
          value: element?.id,
          label: element?.name,
        };
      });
      setLanguages(resultOfLanguages);
    },
  });

  const [runQuerySpeakers] = useLazyQuery(ALL_SPEAKERS, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfSpeakers = data?.allSpeakers?.map((element) => {
        return {
          value: element?.id,
          label: element?.name,
        };
      });
      setSpeakers(resultOfSpeakers);
    },
  });

  const [
    runQueryUsersInRole2,
    { error: errorUsersInRole, loading: loadingUsersInRole },
  ] = useLazyQuery(USERS_IN_ROLE2, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersInRole2 = data.userListAdvancedSearch.map((element) => {
        return {
          value: element?.userId,
          label:
            element?.userFirstName +
            " " +
            element?.userLastName +
            " " +
            element?.userCcms,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
          emailAddress: element?.userTpId,
          ccmsid: element?.userCcms,
          ccmsuser: element?.userCcms,
        };
      });
      setGuestsData(usersInRole2);
    },
  });

  const [runQueryUsersByIds] = useLazyQuery(USERS_BY_IDS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersByIds = data.userAdminlistByIds.map((element) => {
        return {
          value: element?.userId,
          label:
            element?.userFirstName +
            " " +
            element?.userLastName +
            " " +
            element?.userCcms,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
          emailAddress: element?.userEmailAddress,
          ccmsuser: element?.userCcms,
          ccmsid: element?.userCcms,
          userStatus: element?.enabled,
        };
      });

      setIndividualGuests(usersByIds);
    },
  });

  const [runQueryCountry] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data.countryLocationList.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setAllCountries(resultOfAllCountries);
    },
  });

  const [runQueryLobsByCountry] = useLazyQuery(ALL_LOBS_COUNTRY, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllLobs = data.lobsListByCountry.map((element) => {
        return {
          value: element?.lobId,
          label: element?.lobName,
        };
      });
      setAllLobs(resultOfAllLobs);
    },
  });

  const [
    runQueryRolesByLevel,
    { error: errorRoleByLevel, loading: loadingRoleByLevel },
  ] = useLazyQuery(ALL_ROLES_BY_LEVEL, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllRolesByLevel = data.rolesByUserProfile.map((element) => {
        return {
          value: element?.roleId,
          label: element?.friendlyDescription,
          roleLevel: element?.roleLevel,
        };
      });
      setAllRolesByLevel(resultOfAllRolesByLevel);
    },
  });

  let handleChangeComoNoComo = (item) => {
    if (item.value === 1) {
      setSelectedComoNonComo(true);
    } else if (item.value === 2) {
      setSelectedComoNonComo(false);
    } else {
      setSelectedComoNonComo(null);
    }
  };

  useEffect(() => {
    if (dataRecurrence) {
      setRecurrence({
        lastOcurrence: dataRecurrence.lastOcurrence,
        recurrencePattern: dataRecurrence.recurrencePattern,
      });
      handleCloseEventRecurring();
    }
  }, [dataRecurrence]);

  useEffect(() => {
    if (periodRecurring !== "Week") {
      setDataButtonDaysValue([]);
    }
  }, [periodRecurring]);

  useEffect(() => {
    setAction(location.state.idEvent ? "edit" : "add");
    setIdEvent(location.state.idEvent ? location.state.idEvent : "");
  }, [location.state.idEvent]);

  useEffect(() => {
    if (action === "edit" && idEvent) {
      runQueryEventById({
        variables: {
          eventId: idEvent,
        },
      });
    }
  }, [action, idEvent, runQueryEventById]);

  useEffect(() => {
    runQueryCategories();
    if (clientId) {
      runQueryCountryByClient({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }
    runQueryLanguages({ variables: { first: 25 } });
    runQuerySpeakers();
    if (clientId) {
      runQueryCountry({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }

    if (user.roleId) {
      runQueryRolesByLevel({
        variables: { roleId: user.roleId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [clientId, user]);

  useEffect(() => {
    let rolesId = allRolesByLevel.map((element) => {
      return element.value;
    });

    if (user.roleId && rolesId.length > 0) {
      runQueryUsersInRole2({
        variables: { rolesId: rolesId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [allRolesByLevel]);

  useEffect(() => {
    if (!showCreateSpeaker) runQuerySpeakers();
  }, [showCreateSpeaker]);

  useEffect(() => {
    handleUsersAdvanceSearch();
  }, [
    selectedCountry?.countryIds,
    selectedCity?.cityIds,
    selectedRole?.roleIds,
    selectedLob?.lobIds,
    selectedComoNonComo,
  ]);

  let handleCleanEventRecurring = () => {
    setActiveEndsRecurring();
    setRepeatEvery();
    setPeriodRecurring();
    setDataButtonDaysValue([]);
    setOnEndRecurring(null);
  };

  let handleCloseEventRecurring = () => {
    setShowEventRecurring(false);
    handleCleanEventRecurring();
  };

  let handleUsersAdvanceSearch = () => {
    if (selectedComoNonComo !== null) {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountry?.countryIds,
          cities: selectedCity?.cityIds,
          roles: selectedRole?.roleIds,
          lobs: selectedLob?.lobIds,
          isCoMoUser: selectedComoNonComo,
        },
        context: { clientName: "LinkUsers" },
      });
    } else {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountry?.countryIds,
          cities: selectedCity?.cityIds,
          roles: selectedRole?.roleIds,
          lobs: selectedLob?.lobIds,
        },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  let handleCleanSelects = () => {
    setSelectedCountry();
    setSelectedCity();
    setSelectedRole();
    setSelectedLob();
    setUsersAdvanceSearch([]);
    setAllCities([]);
    setTimeout(() => {
      setShowAdvanceOption(true);
    }, 0);
  };

  let handleCities = (countryId) => {
    if (countryId) {
      setAllCities(getCityForCountry(countryId, allCountries));
      runQueryLobsByCountry({
        variables: { countryId: countryId, searchBy: "" },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  const getCityForCountry = (id, list) => {
    let selectedCountry = list.filter((e) => e.countryId === parseInt(id));
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      return citiesArr;
    } else {
      return [];
    }
  };

  let handleCitiesByCountry = (countryId) => {
    if (countryId) setCities(getCityForCountry(countryId, countries));
  };

  let handleUsersByIds = (usersIds) => {
    runQueryUsersByIds({
      variables: { usersIds: usersIds },
      context: { clientName: "LinkUsers" },
    });
  };

  let handleChangeSelectRole = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedRole({
      roles: items,
      roleIds: selectedItems,
    });
  };

  let handleChangeSelectLob = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedLob({
      lobs: items,
      lobIds: selectedItems,
    });
  };

  let handleValideKey = (evt) => {
    if ((evt.which >= 48 && evt.which <= 57) || evt.which === 8) {
      return true;
    } else {
      evt.preventDefault();
    }
  };

  const handleGoToBackPage = () => {
    history.push({ pathname: location.state.path });
  };

  let handleCloseAdvanceSearch = () => {
    setShowAdvanceOption(false);
  };

  let validateData = () => {
    if (periodRecurring === "Day") {
      const rule = new RRule({
        freq: RRule.DAILY,
        interval: repeatEvery,
        until: activeEndsRecurring === "never" ? null : new Date(onEndRecurring),
      });
      setDataRecurrence({
        lastOcurrence: activeEndsRecurring === "never" ? null : onEndRecurring,
        recurrencePattern: rule.toString(),
      });
      setRecurringEvents([{ label: rule.toText(), eventId: idEvent }]);
    }
    if (periodRecurring === "Week") {
      let daysOfRepeatSelectedArray = dataButtonDaysValue.map((element) => {
        return element.value;
      });
      const rule = new RRule({
        freq: RRule.WEEKLY,
        interval: repeatEvery,
        byweekday: daysOfRepeatSelectedArray.map(day => RRule[day]),
        until: activeEndsRecurring === "never" ? null : new Date(onEndRecurring),
      });
      setDataRecurrence({
        lastOcurrence: activeEndsRecurring === "never" ? null : onEndRecurring,
        recurrencePattern: rule.toString(),
      });
      setRecurringEvents([{ label: rule.toText(), eventId: idEvent }]);
    }
    if (periodRecurring === "Month") {
      if (optionForMonthSelected?.value === 0) {
        const rule = new RRule({
          freq: RRule.MONTHLY,
          interval: repeatEvery,
          bysetpos: numberWeek, // Indica el número de la semana
          until: activeEndsRecurring === "never" ? null : new Date(onEndRecurring),
        });
        setDataRecurrence({
          lastOcurrence:
            activeEndsRecurring === "never" ? null : onEndRecurring,
          recurrencePattern: rule.toString(),
        });
        setRecurringEvents([{ label: rule.toText(), eventId: idEvent }]);
      }
      if (optionForMonthSelected?.value === 1) {
        const rule = new RRule({
          freq: RRule.MONTHLY,
          interval: repeatEvery,
          bysetpos: numberWeek,
          byweekday: RRule[dayOfTheMonth], // Especifica el día de la semana
          until: activeEndsRecurring === "never" ? null : new Date(onEndRecurring),
        });
        setDataRecurrence({
          lastOcurrence:
            activeEndsRecurring === "never" ? null : onEndRecurring,
          recurrencePattern: rule.toString(),
        });
        setRecurringEvents([{ label: rule.toText(), eventId: idEvent }]);
      }
    }
    if (periodRecurring === "Year") {
      const rule = new RRule({
        freq: RRule.YEARLY,
        interval: repeatEvery,
        until: activeEndsRecurring === "never" ? null : new Date(onEndRecurring),
      });
      setDataRecurrence({
        lastOcurrence: activeEndsRecurring === "never" ? null : onEndRecurring,
        recurrencePattern: rule.toString(),
      });
      setRecurringEvents([{ label: rule.toText(), eventId: idEvent }]);
    }
  };

  let handleCreateRecurringEvent = () => {
    if (
      (activeEndsRecurring !== "never" && onEndRecurring && repeatEvery) ||
      (activeEndsRecurring === "never" && repeatEvery)
    ) {
      validateData();
    } else {
      NotificationManager.warning(
        "These fields are required for create a recurrence",
        "",
        5000
      );
    }
  };

  let handleUpdateRecurringEvent = () => {
    if (
      (activeEndsRecurring !== "never" && onEndRecurring && repeatEvery) ||
      (activeEndsRecurring === "never" && repeatEvery)
    ) {
      validateData();
    } else {
      NotificationManager.warning(
        "These fields are required for update a recurrence",
        "",
        5000
      );
    }
  };

  let handleEditRecurring = (item) => {
    handleCleanEventRecurring();
    if (item.label !== "") {
      setShowEventRecurring(true);
      setShowUpdateRecurringButton(true);
      let ruleEdit = RRule.fromText(item.label);
      setRepeatEvery(
        ruleEdit.origOptions.interval ? ruleEdit.origOptions.interval : 1
      );
      switch (ruleEdit.origOptions.freq) {
        case 0:
          setPeriodRecurring("Year");
          break;
        case 1:
          setPeriodRecurring("Month");
          break;
        case 2:
          setPeriodRecurring("Week");
          break;
        case 3:
          setPeriodRecurring("Day");
          break;
        default:
          break;
      }
      setActiveEndsRecurring(ruleEdit.origOptions.until ? "on" : "never");
      setOnEndRecurring(
        ruleEdit.origOptions.until
          ? moment(ruleEdit.origOptions.until).format("YYYY-MM-DD")
          : null
      );
      setDataButtonDaysValue(
        ruleEdit.origOptions.byweekday
          ? ruleEdit.origOptions.byweekday.map((item) => {
            switch (item.weekday) {
              case 0:
                return "Monday";
              case 1:
                return "Tuesday";
              case 2:
                return "Wednesday";
              case 3:
                return "Thursday";
              case 4:
                return "Friday";
              case 5:
                return "Saturday";
              case 6:
                return "Sunday";
              default:
                break;
            }
          })
          : []
      );
      if (ruleEdit.origOptions.freq === 3) {
        setOptionForMonthSelected(
          ruleEdit.origOptions.bymonthday
            ? { label: `${item.label}`, value: 0 }
            : { label: `${item.label}`, value: 1 }
        );
      }
    } else {
      NotificationManager.warning(
        "This recurrence doesn't exist in this event",
        "",
        5000
      );
    }
  };

  let handleDeleteRecurring = (item) => {
    let errorMessage = "";
    if (item.eventId) {
      deleteRecurrence({
        variables: {
          eventId: item.eventId,
        },
      })
        .then((response) => {
          if (errorMessage === "") {
            let recurringArr = [...recurringEvents];
            recurringArr.splice(
              recurringArr.findIndex((f) => f.eventId === item.eventId),
              1
            );
            setRecurringEvents(recurringArr);
            setRenderAgain(!renderAgain);
            NotificationManager.success(
              "The recurring events has been removed",
              "",
              5000
            );
            setOpenDeleteRecurringModal(null);
          } else {
            NotificationManager.error(errorMessage, "", 5000);
          }
        })
        .catch((error) => {
          errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      let recurringArr = [...recurringEvents];
      recurringArr.splice(
        recurringArr.findIndex((f) => f.eventId === item.eventId),
        1
      );
      setRecurringEvents(recurringArr);
      setRenderAgain(!renderAgain);
      setOpenDeleteRecurringModal(null);
    }
  };

  return (
    <GeneralContainer>
      {action && (
        <ManageEvent
          action={action}
          idEvent={idEvent}
          usersAdvanceSearch={usersAdvanceSearch}
          detailEvent={detailEvent}
          categories={categories}
          countries={countries}
          cities={cities}
          languages={languages}
          speakers={speakers}
          guestsData={guestsData}
          individualGuests={individualGuests}
          showCreateSpeaker={showCreateSpeaker}
          allCountries={allCountries}
          allCities={allCities}
          allLobs={allLobs}
          allRolesByLevel={allRolesByLevel}
          selectedCountry={selectedCountry}
          selectedCity={selectedCity}
          selectedRole={selectedRole}
          selectedLob={selectedLob}
          showAdvanceOption={showAdvanceOption}
          loadingEventById={loadingEventById}
          errorEventById={errorEventById}
          loadingRoleByLevel={loadingRoleByLevel}
          errorRoleByLevel={errorRoleByLevel}
          loadingUsersInRole={loadingUsersInRole}
          errorUsersInRole={errorUsersInRole}
          setSelectedCountry={setSelectedCountry}
          setSelectedCity={setSelectedCity}
          setUsersAdvanceSearch={setUsersAdvanceSearch}
          setIndividualGuests={setIndividualGuests}
          setShowCreateSpeaker={setShowCreateSpeaker}
          setAllCities={setAllCities}
          setCities={setCities}
          handleGoToBackPage={handleGoToBackPage}
          handleCitiesByCountry={handleCitiesByCountry}
          handleCities={handleCities}
          handleUsersByIds={handleUsersByIds}
          handleCleanSelects={handleCleanSelects}
          handleChangeSelectRole={handleChangeSelectRole}
          handleChangeSelectLob={handleChangeSelectLob}
          handleCloseAdvanceSearch={handleCloseAdvanceSearch}
          handleValideKey={handleValideKey}
          handleCleanEventRecurring={handleCleanEventRecurring}
          showUpdateRecurringButton={showUpdateRecurringButton}
          setShowUpdateRecurringButton={setShowUpdateRecurringButton}
          setShowEventRecurring={setShowEventRecurring}
          showEventRecurring={showEventRecurring}
          handleCloseEventRecurring={handleCloseEventRecurring}
          repeatEvery={repeatEvery}
          setRepeatEvery={setRepeatEvery}
          dateOptions={dateOptions}
          periodRecurring={periodRecurring}
          setPeriodRecurring={setPeriodRecurring}
          dataButtonDays={dataButtonDays}
          dataButtonDaysValue={dataButtonDaysValue}
          optionForMonth={optionForMonth}
          optionForMonthSelected={optionForMonthSelected}
          setOptionForMonthSelected={setOptionForMonthSelected}
          dataEndsDate={dataEndsDate}
          activeEndsRecurring={activeEndsRecurring}
          setActiveEndsRecurring={setActiveEndsRecurring}
          onEndRecurring={onEndRecurring}
          setOnEndRecurring={setOnEndRecurring}
          handleCreateRecurringEvent={handleCreateRecurringEvent}
          handleUpdateRecurringEvent={handleUpdateRecurringEvent}
          setRecurringEvents={setRecurringEvents}
          recurringEvents={recurringEvents}
          handleEditRecurring={handleEditRecurring}
          setOpenDeleteRecurringModal={setOpenDeleteRecurringModal}
          openDeleteRecurringModal={openDeleteRecurringModal}
          handleDeleteRecurring={handleDeleteRecurring}
          recurrence={recurrence}
          handleChangeComoNoComo={handleChangeComoNoComo}
        />
      )}
    </GeneralContainer>
  );
};

export default ManageEventContainer;
